import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { useStyles } from "../../../theme/appStyles";
import {
  useGetTeamQuery,
  useGetDepartmentQuery,
  useGetPositionQuery,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import {
  ITeam,
  IDepartment,
  IPosition,
} from "../../../Api/Interface/api.interface";
import NewPopUpteam from "../Edit/index";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import InfoIcon from "@mui/icons-material/Info";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import HistoryIcon from "@mui/icons-material/History";
import NoteIcon from "@mui/icons-material/Note";
import ReactToPrint from "react-to-print";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { companyLogo, logowidthPrint, companyName } = useSelector(
    (state: RootState) => state.company
  );
  const theme = useTheme();
  const { id: customerId } = useParams<{ id: string }>();
  useEffect(() => {}, [customerId]);
  const componentRef = useRef<HTMLDivElement>(null);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const { data, isLoading, isError } = useGetTeamQuery({
    searchText: "",
    id: String(customerId),
  });

  const { data: departmentData, isLoading: departmentLoading } =
    useGetDepartmentQuery({
      searchText: "",
    });

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const departmentList = useMemo(() => {
    return departmentData?.data as IDepartment[];
  }, [departmentData?.data]);

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const departmentMap = useMemo(() => {
    const map = new Map();
    departmentList?.forEach((category) => {
      map.set(category.id, category.departmentName);
    });
    return map;
  }, [departmentList]);

  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  const customer = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as ITeam;
    }
    return null;
  }, [data]);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.quotesCardInvoice}>
            <Grid container spacing={1} padding={"2px"}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <Button
                      variant="outlined"
                      endIcon={<ArrowForwardIosIcon />}
                      className={classes.addButton}
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <div ref={componentRef}>
            <Card className={classes.quotesCardInvoice}>
              <Grid container spacing={1} padding={"2px"}>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className={classes.titleGrid}
                >
                  <Grid
                    container
                    className={classes.titleGridInvoice}
                    justifyContent={"space-between"}
                    padding={3}
                  >
                    <Grid item lg={12} md={12} sm={12} xs={12} pb={2}>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="center"
                        >
                          <Typography className={classes.bodyPrintHeading}>
                          {companyName} -
                            {(customer?.teamFirstName || "") +
                              "" +
                              (customer?.teamLastName || "")}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="center"
                        >
                          <img
                            src={companyLogo}
                            alt="Ocr"
                            style={{
                              width: "250px",
                              height: "auto",
                              display: "block",
                            }}
                          />
                        </Grid>

                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          mt={5}
                          className={classes.titleGrid}
                        >
                          <Grid container spacing={2}>
                            <Grid item lg={12} md={12} sm={12} xs={12} pb={3}>
                              {customer &&
                                (customer.teamFirstName ||
                                  customer.teamLastName) && (
                                  <Typography
                                    className={classes.bodyPrintHeading}
                                    sx={{
                                      textTransform: "uppercase",
                                      color: "black",
                                    }}
                                  >
                                    {(customer?.teamFirstName || "") +
                                      "" +
                                      (customer?.teamLastName || "")}
                                  </Typography>
                                )}
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TableContainer>
                                <Table className={classes.table}>
                                  <TableHead className={classes.tableHeaderRow}>
                                    <TableRow>
                                      <TableCell className={classes.tablheader}>
                                        <strong>Day</strong>
                                      </TableCell>
                                      <TableCell
                                        className={classes.tablheader}
                                        sx={{ textAlign: "right" }}
                                      >
                                        <strong>Start Time</strong>
                                      </TableCell>
                                      <TableCell
                                        className={classes.tablheader}
                                        sx={{ textAlign: "right" }}
                                      >
                                        <strong>End Time</strong>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {customer?.availability
                                      .filter((day) => day.timeSlots.length > 0) // Only include days with timeSlots
                                      .map((day) =>
                                        day.timeSlots.map((slot) => (
                                          <TableRow
                                            key={`${day.day}-${slot.id}`}
                                            className={classes.tableRowHover}
                                          >
                                            <TableCell
                                              className={classes.tablCell}
                                              align="right"
                                            >
                                              {day.day}
                                            </TableCell>
                                            <TableCell
                                              className={classes.tablCell}
                                              align="right"
                                            >
                                              {slot.startTime}
                                            </TableCell>
                                            <TableCell
                                              className={classes.tablCell}
                                              align="right"
                                            >
                                              {slot.endTime}
                                            </TableCell>
                                          </TableRow>
                                        ))
                                      )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </div>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.quotesCardInvoice}>
            <Grid container spacing={1} padding={"2px"}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <ReactToPrint
                      trigger={() => (
                        <Button
                          variant="contained"
                          startIcon={<LocalPrintshopSharpIcon />}
                          className={classes.addButton}
                        >
                          Print
                        </Button>
                      )}
                      content={() => componentRef.current}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
